
import { Component, Vue } from 'vue-property-decorator';

import Modal from '@/globalComponents/Modal/Modal.vue';
import PlusPlanIcon from '@/assets/icons/PlusPlan.vue';
import CheckPlanIcon from '@/assets/icons/checkPlan.vue';

import { URLS_PLAN_FREE } from '@/constant/FreePlanUrls';

@Component({
  components: {
    Modal,
    PlusPlanIcon,
    CheckPlanIcon
  }
})
export default class ModalPopUpPlanFree extends Vue {
  private URLS_PLAN_FREE = URLS_PLAN_FREE;
}
